<template>
  <b-form-group :label="label" :state="state">
    <b-form-file
      ref="fileInput"
      v-model="internalFile"
      :state="state"
      placeholder="Drag & drop Excel file or click to browse..."
      drop-placeholder="Drop file here..."
      accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      @input="handleInput"
    />
    <div v-if="internalFile" class="file-info mt-2 d-flex align-items-center">
      <i class="fas fa-file-excel text-success mr-2"></i>
      <span class="badge badge-success mr-2">{{ internalFile.name }}</span>
      <small class="text-muted mr-2">{{ formatFileSize(internalFile.size) }}</small>
      <b-button size="sm" variant="link" class="text-danger p-0" @click="clearFile">
        <i class="fas fa-times"></i>
      </b-button>
    </div>
    <b-form-invalid-feedback v-if="errorMessage" force-show>
      {{ errorMessage }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const VALID_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];

export default {
  name: 'ExcelFileUploader',
  props: {
    value: { type: File, default: null },
    label: { type: String, default: 'Upload Excel File' },
    state: { type: Boolean, default: null }
  },
  data() {
    return {
      internalFile: null,
      errorMessage: ''
    };
  },
  watch: {
    value(newVal) {
      this.internalFile = newVal;
    }
  },
  methods: {
    handleInput(file) {
      this.errorMessage = '';
      if (!file) {
        this.$emit('input', null);
        return;
      }
      const isValidType = VALID_TYPES.includes(file.type) ||
        file.name.endsWith('.xls') ||
        file.name.endsWith('.xlsx');
      if (!isValidType) {
        this.errorMessage = 'Please upload a valid Excel file (.xls or .xlsx)';
        this.clearFile();
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        this.errorMessage = 'File size must be less than 10MB';
        this.clearFile();
        return;
      }
      this.$emit('input', file);
    },
    clearFile() {
      this.internalFile = null;
      this.$emit('input', null);
      if (this.$refs.fileInput) {
        this.$refs.fileInput.reset();
      }
    },
    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }
  }
};
</script>

<style scoped>
.file-info {
  background-color: #f8f9fa;
  padding: 0.5rem;
  border-radius: 0.25rem;
}
</style>
